import React, { useState } from 'react';
import { loginFields } from "../constants/formFields";
import FormAction from "./FormAction";
import FormExtra from "./FormExtra";
import Input from "./Input";
import { send } from '../services/api';
import { useNavigate } from 'react-router-dom';

const fields = loginFields;
let fieldsState = {};

fields.forEach(field => fieldsState[field.id] = '');

export default function Login() {
    const [loginState, setLoginState] = useState(fieldsState);
    const [formErrors, setFormErrors] = useState({});
    const [permission, setPermission] = useState()


    const navigate = useNavigate();

    const handleChange = (e) => {
        setPermission('')
        setLoginState({ ...loginState, [e.target.id]: e.target.value });
        // Clear the error message for the field being edited
        clearError(e.target.id);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        validateForm();
    }

    const validateForm = async () => {
        const errors = {};

        if (loginState.email.length === 0) {
            errors.email = 'Email Address cannot be empty';
        } else {
            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            if (!emailRegex.test(loginState.email)) {
                errors.email = 'Please enter a valid email address';
            }
        }

        if (loginState.password.length === 0) {
            errors.password = 'Password Field cannot be empty';
        }
        // else {
        //     const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        //     if (!passwordRegex.test(loginState.password)) {
        //         errors.password = 'Password must contain at least one digit, one lowercase letter, one uppercase letter, and have a minimum length of 8 characters.';
        //     }
        // }

        if (Object.keys(errors).length === 0) {
            await send(loginState)
                .then(response => {
                    if (response.status === 200) {
                        setPermission({ message: response.data.error ? response.data.error : '', status: response.status })
                        const data = JSON.stringify(response.data)
                        localStorage.setItem('userObj', data)
                        setTimeout(() => {
                            setPermission('')
                            navigate('/streetchart');
                        }, 2000)
                    } else {
                        setPermission({ message: response.data.error ? response.data.error : '', status: response.status })
                    }
                })
        } else {
            setFormErrors(errors)
        }
    }

    // Function to clear the error for a specific field when it's focused
    const clearError = (fieldId) => {
        setFormErrors((prevErrors) => {
            return { ...prevErrors, [fieldId]: '' };
        });
    };

    return (
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            {permission ?
                <h5 className={`${permission.status === 200 ? 'bg-green-500' : 'bg-red-500'} p-2 text-white`}
                >{permission.status === 200 ? 'Login Successfully' : permission.message}</h5>
                : ''}
            <div className="-space-y-px">
                {fields.map(field => (
                    <div key={field.id} className="relative">
                        <label htmlFor={field.id} className="sr-only">
                            {field.labelText}
                        </label>
                        <Input
                            id={field.id}
                            name={field.name}
                            type={field.type}
                            autoComplete={field.autoComplete}
                            className={`input ${formErrors[field.id] ? 'input-error' : ''}`}
                            placeholder={field.placeholder}
                            value={loginState[field.id]}
                            handleChange={handleChange}
                        />
                        {formErrors[field.id] && (
                            <div className="absolute top-0 right-0 -mt-6 mr-2 bg-red-500 text-white text-xs p-1 rounded">
                                {formErrors[field.id]}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <FormExtra />
            <FormAction handleSubmit={handleSubmit} text="Login" />
        </form>
    );
}
